import axios from "axios";
import {detailServicesPath} from "../../../Constants";

const detailControllerRestUrl = detailServicesPath + '/organizations/grooves'

export default class GrooveControllerServiceOrganization {
    static async add(detailId, data) {
        return await axios.post(`${detailControllerRestUrl}?detailId=${detailId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(grooveId) {
        return await axios.delete(`${detailControllerRestUrl}/${grooveId}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async put(grooveId, data) {
        return await axios.put(`${detailControllerRestUrl}/${grooveId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}
